import { useContext } from 'react';
import PropTypes from 'prop-types';

import { StateContext } from 'state/state-context';
import { roundedInput, formLabel } from './styles.module.scss';
import { ValidationMessage } from 'components/ValidationMessage/ValidationMessage';

const enterKey = 'Enter';

export const Input = ({ name, label, defaultValue = '', validationMessage, ...other }) => {
  const { form, content } = useContext(StateContext);
  const state = form.state[name];
  const value = state ? state.value : defaultValue;
  const copy = content(name);

  return (
    <div className="row">
      <div className="col">
        <label className={`${formLabel}`} htmlFor={name}>
          {copy.label}
          <ValidationMessage name={name} />
        </label>
        <input
          className={`${roundedInput} s12`}
          name={name}
          id={name}
          value={value}
          onChange={(e) => {
            form.setValue(name, e.target.value);
          }}
          onBlur={() => form.onBlur(name)}
          onKeyPress={(e) => {
            if (e.key === enterKey) {
              form.onBlur(name);
            }
          }}
          autoComplete="off"
          {...other}
        />
      </div>
    </div>
  );
};

Input.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  defaultValue: PropTypes.string,
  validationMessage: PropTypes.string,
  format: PropTypes.string
};
